export default "__VITE_ASSET__794156c0__"